import { combine, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as sessionModel } from '~/entities/session'

const $copyrightText = combine(i18n.$t, ({ t }) => t('footer_copyright_text'))

const $privacyPolicy = combine(i18n.$t, ({ t }) => t('privacy_policy'))

const $termsOfAgreement = combine(i18n.$t, ({ t }) => t('terms_of_agreements'))

const $promoText = combine(i18n.$t, ({ t }) => t('footer_promo_text'))

// this value is an empty space lower at the bottom of the page to put sticky Message there.
export const $adjustHeight = createStore<number | null>(null)

register($privacyPolicy, '$privacyPolicy')
register(sessionModel.$hasToa, '$hasToa')
register($termsOfAgreement, '$termsOfAgreement')
register($copyrightText, '$copyrightText')
register($promoText, '$promoText')
register($adjustHeight, '$adjustHeight')
